import { ComparisonDifferenceMode } from 'settings/enums/comparison.enum';

export interface CategoryReorderResponse {
    source: IceCategoryOrderSourceEnum;
    groups: CategoryGroup[];
}

export interface TranslationEntry {
    language: string;
    name: string;
}

export interface IceCategory {
    categoryId: number;
    sortOrder: number;
    categoryTranslations: TranslationEntry[];
}

export interface CategoryGroup {
    groupId: number;
    sortOrder: number;
    groupTranslations: TranslationEntry[];
    iceCategories: IceCategory[];
}

export interface MappedCategoryReorder {
    id: number;
    order: number;
    name: string;
    subCategories?: MappedSubCategoryReorder[];
}

export interface MappedSubCategoryReorder {
    id: number;
    order: number;
    name: string;
}

export enum CategoryReorderTypeEnum {
    SYSTEM = 'SYSTEM',
    SUPPLIER = 'SUPPLIER',
    BRAND = 'BRAND',
    LISTING = 'LISTING',
}

export enum IceCategoryOrderSourceEnum {
    SYSTEM = 'SystemDefault',
    SUPPLIER = 'Supplier',
    CHAIN = 'Chain',
    LISTING = 'Listing',
}

export const CategoryReorderTypeToIceCategoryOrderSourceMap: Record<IceCategoryOrderSourceEnum, CategoryReorderTypeEnum> = {
    [IceCategoryOrderSourceEnum.SYSTEM]: CategoryReorderTypeEnum.SYSTEM,
    [IceCategoryOrderSourceEnum.SUPPLIER]: CategoryReorderTypeEnum.SUPPLIER,
    [IceCategoryOrderSourceEnum.CHAIN]: CategoryReorderTypeEnum.BRAND,
    [IceCategoryOrderSourceEnum.LISTING]: CategoryReorderTypeEnum.LISTING,
};

export interface CategoryChange {
    type: ComparisonDifferenceMode.REORDERED | ComparisonDifferenceMode.UNCHANGED;
    category: MappedCategoryReorder;
}

export interface SubCategoryChange {
    type: ComparisonDifferenceMode.REORDERED | ComparisonDifferenceMode.UNCHANGED;
    subCategory: MappedSubCategoryReorder;
}
